import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button, { ILink } from '../Button';
import Icon from '../Icon';
import Image, { IImage } from '../Image';
import Nav, { NavItem } from '../Nav';
export interface IVHSFooterSocial {
	/**
	 * Link
	 */
	link?: ILink;
	/**
	 * Icon
	 */
	icon?: string;
}
export interface IVHSFooterBottomNav {
	/**
	 * Link
	 */
	link?: ILink;
}
export interface IVHSFooterProps extends IBaseElementProps {
	logo?: IImage;
	logoURL?: string;
	address?: string;
	social?: IVHSFooterSocial[];
	mainNav?: NavItem[];
	copyright: string;
	disclaimer?: string;
	bottomNav?: IVHSFooterBottomNav[];
}

const VHSFooter: React.FC<IVHSFooterProps> = ({
	logo,
	logoURL,
	address,
	social = [],
	mainNav,
	copyright,
	disclaimer,
	bottomNav = [],
	className,
	classNames = [],
}) => (
	<footer className={className || cn('vhs-footer', ...classNames)}>
		<div className="vhs-footer__container">
			<div className="vhs-footer__top">
				<div className="vhs-footer__wrapper">
					<div className="vhs-footer__top-content">
						<div className="vhs-footer__top-left">
							{logo?.src && (
								<a className="vhs-footer__logo" href={logoURL}>
									<Image {...logo} className="img-fluid" />
								</a>
							)}
							{address && (
								<div
									className="vhs-footer__address"
									dangerouslySetInnerHTML={{
										__html: address,
									}}
								/>
							)}
							{social.length > 0 && (
								<ul className="vhs-footer__social">
									{social.map(({ icon, link }, index) => (
										<li key={index}>
											<a
												href={link.href}
												target="_blank"
												rel={
													link?.target === '_blank'
														? 'noopener noreferrer'
														: ''
												}
												aria-label={link.label}
											>
												{icon && <Icon name={icon} />}
											</a>
										</li>
									))}
								</ul>
							)}
						</div>
						<div className="vhs-footer__top-right">
							{mainNav && mainNav.length > 0 && (
								<Nav
									navItems={mainNav}
									collapseEnabled
									dropdownEnabled={false}
									classNames={['vhs-footer__top-nav']}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
			<div className="vhs-footer__bottom">
				<div className="vhs-footer__wrapper">
					<div className="vhs-footer__bottom-content">
						<div className="vhs-footer__bottom-left">
							{disclaimer && (
								<div className="vhs-footer__disclaimer">
									{disclaimer}
									<div className="vhs-footer__copyright">
										{copyright}
									</div>
								</div>
							)}
						</div>
						<div className="vhs-footer__bottom-right">
							<div className="vhs-footer__nav">
								{bottomNav.length > 0 && (
									<ul className="vhs-footer__bottom-nav">
										{bottomNav.map(({ link }, index) => (
											<li key={index}>
												<a
													href={link.href}
													target={link.target}
													rel={
														link?.target ===
														'_blank'
															? 'noopener noreferrer'
															: ''
													}
												>
													{link.label && (
														<span>
															{link.label}
														</span>
													)}
												</a>
											</li>
										))}
									</ul>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
);

export default VHSFooter;
